export function SkipToContent() {
  return (
    <a href="#main" className="skip-link">
      Skip to content
    </a>
  );
}

export default SkipToContent;
